<div class="position-relative">
  <div class="feedback__form-container" [class.opacity-0]="feedbackSubmitted">
    <h3 class="mb-2" i18n>How did we do?</h3>
    <p class="mb-1" i18n>Please rate your renewals experience</p>

    <form
      class="feedback__form position-relative"
      [formGroup]="controller"
      locktonAppsFormGroupValidation
      #formValidation="validation"
      (ngSubmit)="submitFeedback(controller.value)"
    >
      <div class="feedback__scoreboard d-flex flex-column mb-2">
        <div class="d-flex">
          <div
            class="position-relative"
            *ngFor="let score of scores; let last = last"
            [class.me-1]="!last"
          >
            <input
              class="feedback__score-input position-absolute w-100 h-100 opacity-0"
              type="radio"
              formControlName="rate"
              [id]="score.value"
              [value]="score.value"
            />
            <label [for]="score.value" class="feedback__score-label d-block">
              <mat-icon class="w-100 h-100" [svgIcon]="score.icon"></mat-icon>
            </label>
          </div>
        </div>

        <mat-error>
          <ng-container *ngIf="controller.touched && controller.dirty">
            {{ formValidation.getMessageForControl('rate') }}
          </ng-container>
        </mat-error>
      </div>

      <mat-form-field>
        <mat-label i18n>Could we improve this experience?</mat-label>
        <textarea
          class="feedback__comment"
          matInput
          formControlName="comment"
          [rows]="5"
        ></textarea>
      </mat-form-field>

      <button type="submit" class="mt-1 ms-auto d-block" luiButton i18n>
        Submit feedback
      </button>
    </form>
  </div>

  <div
    *ngIf="feedbackSubmitted"
    @slide
    class="feedback__thank-you position-absolute w-100 h-100 d-flex flex-column justify-content-center"
  >
    <h3 class="mb-1" i18n>Thank you!</h3>
    <p i18n>
      Your feedback is invaluable in helping us to keep improving our services.
    </p>
  </div>
</div>
